import Vue from 'vue';
import Vuex from 'vuex';

import LeftSidebarCreate from './modules/LeftSidebar/create';
import editquestionEdit from './modules/editquestion/edit';
import editquestion from './modules/editquestion/index';
import previewSurvey from './modules/PreviewSurvey/index';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    LeftSidebarCreate,
    editquestionEdit,
    editquestion,
    previewSurvey
  },
  strict: false
})



// WEBPACK FOOTER //
// ./src/store/index.js